import { render, staticRenderFns } from "./stockcalculation.vue?vue&type=template&id=0a82dd52&scoped=true&"
import script from "./stockcalculation.vue?vue&type=script&lang=js&"
export * from "./stockcalculation.vue?vue&type=script&lang=js&"
import style0 from "./stockcalculation.vue?vue&type=style&index=0&id=0a82dd52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82dd52",
  null
  
)

export default component.exports